import type { ReactNode } from "react"

interface Props {
  title: ReactNode
  /** Optional element shown to the right of the title (e.g. a status pill) */
  badge?: ReactNode
  /** Subtitle row content (numbers, country, etc.) */
  meta?: ReactNode
  /** Relation count badges. Sit to the right of `meta` on the same line when
   * there's room; when the row is too narrow to fit both, the badge group
   * (kept together as one flex item) wraps down to its own row below. */
  badges?: ReactNode
}

export function EntityListRowContent({ title, badge, meta, badges }: Props) {
  return (
    <div className="flex min-w-0 flex-1 flex-col gap-0.5">
      <div className="flex items-center justify-between gap-2">
        <span className="truncate text-sm font-medium text-white">{title}</span>
        {badge && <div className="shrink-0">{badge}</div>}
      </div>
      {(meta || badges) && (
        <div className="flex min-w-0 flex-wrap items-center justify-between gap-x-3 gap-y-1">
          {meta && (
            <div className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1 text-xs text-grey5">
              {meta}
            </div>
          )}
          {badges && (
            <div className="flex flex-wrap items-center gap-2">{badges}</div>
          )}
        </div>
      )}
    </div>
  )
}
